export default function ResearchAutomation() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="mb-12">
          <div className="inline-block bg-primary text-white px-6 py-3 rounded-lg font-bold text-lg mb-4">
            ① 商品リサーチの自動化
          </div>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-12">
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-user-line text-primary"></i>
              人力だと
            </h3>
            <ul className="space-y-4">
              {['Keepa見る', 'ランキング見る', '価格差計算', 'Excel貼り付け'].map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <i className="ri-close-circle-line text-red-500 text-xl mt-1"></i>
                  <span className="text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
          </div>
          
          <div className="bg-primary/5 border-2 border-primary rounded-2xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-primary mb-6 flex items-center gap-3">
              <i className="ri-robot-line"></i>
              自動化後
            </h3>
            <div className="space-y-6">
              <div>
                <h4 className="font-bold text-gray-900 mb-3">方法</h4>
                <ul className="space-y-2">
                  {['Keepa API', 'SP-API', 'Octoparse', 'CSVインポート'].map((item, index) => (
                    <li key={index} className="flex items-center gap-2">
                      <i className="ri-check-line text-primary text-xl"></i>
                      <span className="text-gray-700">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="bg-white rounded-lg p-4">
                <p className="text-gray-800 font-medium">
                  → スプレッドシートに自動取得。
                </p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-2xl p-8 shadow-lg mb-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-6">データ構成</h3>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-primary text-white">
                  <th className="px-4 py-3 text-left font-bold">項目</th>
                  <th className="px-4 py-3 text-left font-bold">ASIN</th>
                  <th className="px-4 py-3 text-left font-bold">現在価格</th>
                  <th className="px-4 py-3 text-left font-bold">月販</th>
                  <th className="px-4 py-3 text-left font-bold">FBA手数料</th>
                  <th className="px-4 py-3 text-left font-bold">利益</th>
                  <th className="px-4 py-3 text-left font-bold">利益率</th>
                  <th className="px-4 py-3 text-left font-bold">競合数</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-200">
                  <td className="px-4 py-3 text-gray-600" colSpan={8}>
                    自動取得されるデータ項目
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        
        <div className="bg-gradient-to-br from-primary to-primary-dark text-white rounded-2xl p-8 shadow-lg">
          <h3 className="text-2xl font-bold mb-6">判定ロジック</h3>
          <div className="bg-white/10 rounded-xl p-6 font-mono text-sm mb-6">
            <pre className="whitespace-pre-wrap">
{`IF(
  利益率 > 20%
  AND 月販 > 50
  AND 競合数 < 10
)
→ 仕入れ対象`}
            </pre>
          </div>
          <div className="flex items-center gap-3 text-xl font-bold">
            <i className="ri-check-double-line text-3xl"></i>
            <span>これで"仕入れ判断"が完全自動化。</span>
          </div>
        </div>
      </div>
    </section>
  );
}
